import { required } from 'vuelidate/lib/validators'

export default {
  to: {
    agenda_id: {
      required
    },
    schedule_id: {
      required
    }
  },
  date: {
    required
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/professional/gadget/components/active-agenda/components/transfer/resources/validations.js